// extracted by mini-css-extract-plugin
export var option = "_4o-0";
export var optionCard = "_4o-f";
export var optionContent = "_4o-g";
export var optionIcon = "_4o-i";
export var optionIconBox = "_4o-h";
export var optionLabel = "_4o-j";
export var optionPill = "_4o-m";
export var optionPillBadge = "_4o-p";
export var optionPillIcon = "_4o-n";
export var optionPillLabel = "_4o-o";
export var optionRadio = "_4o-k";
export var optionRadioInner = "_4o-l";
export var optionReveal = "_4o-2";
export var optionRevealDelay0 = "_4o-3";
export var optionRevealDelay1 = "_4o-4";
export var optionRevealDelay10 = "_4o-d";
export var optionRevealDelay11 = "_4o-e";
export var optionRevealDelay2 = "_4o-5";
export var optionRevealDelay3 = "_4o-6";
export var optionRevealDelay4 = "_4o-7";
export var optionRevealDelay5 = "_4o-8";
export var optionRevealDelay6 = "_4o-9";
export var optionRevealDelay7 = "_4o-a";
export var optionRevealDelay8 = "_4o-b";
export var optionRevealDelay9 = "_4o-c";
export var optionSelected = "_4o-1";